/* eslint-disable no-dupe-keys */
export default {
  start_appointment: {
    name: '充电启动预约',
    // 属性（一般与对象内容匹配）
    prop: {
      charge_station: '充电站',
      charger: '充电桩',
      recurrence_type: '重复周期',
      start_time: '启动时间',
      stop_time: '停止时间',
      status: '状态',
      user: '充电用户',
      created_at: '创建时间',
      updated_at: '更新时间',
      last_start_executed_at: '最后启动执行',
      last_stop_executed_at: '最后停止执行'
    },
    // Enum的属性
    recurrence_types: {
      once: '一次',
      everyday: '每天'
    },
    statuses: {
      enabled: '已激活',
      disabled: '已取消'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询站名/桩编号'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标题
    titles: {
      base_info: '基本信息'
    },
    labels: {
      total_once_active_count: '一次预约数 (激活)',
      total_everyday_active_count: '每日预约数 (激活)'
    },
    tips: {
      stop_charge_desc: '设置用户后，只有该用户启动的订单才会下发停止；不设置则统一强制停止'
    }
  }
}
